// ----------------------------------------------------------------------
// Event Co-Organizers Translations - French
// ----------------------------------------------------------------------

export const coOrganizersFr = {
  co_organizers: {
    title: 'Co-Organisateurs',
    tab_title: 'Co-Organisateurs',
    description: 'G\u00e9rez les organisations qui co-organisent cet \u00e9v\u00e9nement avec vous.',
    add_co_organizer: 'Ajouter un co-organisateur',
    max_reached: 'Maximum de 2 co-organisateurs atteint',
    search_placeholder: 'Rechercher une organisation...',
    no_co_organizers: 'Aucun co-organisateur ajout\u00e9.',
    no_co_organizers_description:
      "Ajoutez d'autres organisations pour collaborer sur cet \u00e9v\u00e9nement. Vous pouvez ajouter jusqu'\u00e0 2 co-organisateurs.",
    permissions: 'Autorisations',
    view_general: 'Voir les donn\u00e9es g\u00e9n\u00e9rales',
    view_general_description: "Acc\u00e8s aux onglets G\u00e9n\u00e9ral, Aper\u00e7u et Pr\u00e9visualisation",
    view_sales: 'Voir les donn\u00e9es de vente',
    view_sales_description:
      'Acc\u00e8s aux onglets Tableau de bord, Donn\u00e9es des billets et Distribution des parts',
    view_analytics: 'Voir les analyses',
    view_analytics_description: "Acc\u00e8s \u00e0 l'onglet Analyses",
    edit_event: "Modifier l'\u00e9v\u00e9nement",
    edit_event_description:
      'Possibilit\u00e9 de modifier G\u00e9n\u00e9ral, Dates, Billets et Publier',
    remove: 'Retirer le co-organisateur',
    remove_confirm:
      "\u00cates-vous s\u00fbr de vouloir retirer ce co-organisateur ? Il perdra tout acc\u00e8s \u00e0 cet \u00e9v\u00e9nement.",
    added_success: 'Co-organisateur ajout\u00e9 avec succ\u00e8s',
    updated_success: 'Autorisations du co-organisateur mises \u00e0 jour avec succ\u00e8s',
    removed_success: 'Co-organisateur retir\u00e9 avec succ\u00e8s',
    cannot_add_self: "Impossible d'ajouter l'organisateur principal comme co-organisateur",
    already_added: 'Cette organisation est d\u00e9j\u00e0 co-organisatrice',
    max_error: 'Maximum 2 co-organisateurs autoris\u00e9s',
    co_organized_event: 'Co-organis\u00e9',
    co_organizer_badge: 'Co-organisateur',
    select_permissions: 'S\u00e9lectionnez les autorisations pour ce co-organisateur',
    no_results: 'Aucune organisation trouv\u00e9e',
    save: 'Enregistrer',
    cancel: 'Annuler',
    confirm: 'Confirmer',
    add: 'Ajouter',
    select_org: 'S\u00e9lectionner une organisation',
    notification_view_event: "Voir l'\u00e9v\u00e9nement",
  },
};
